export default __webpack_public_path__ + "static/media/logo.054906dd.png";